module.exports = __webpack_public_path__ + "c97ff218f40c1a32d9a33f44791a59b4.pdf";